<template>
  <div>
    <v-icon
      v-for="n in confidence"
      color="green accent-4"
      :small="small"
      :key="n"
      >check</v-icon
    >
    <v-icon
      v-for="n in 3 - confidence"
      color="grey lighten-1"
      :small="small"
      :key="n + 3"
      >check</v-icon
    >
  </div>
</template>

<script>
export default {
  props: ["confidence", "small"]
};
</script>
